import BaseMemberContextProvider from '../../state/member/baseMember/BaseMemberContextProvider';

import BasePersonContextProvider from '@usas/ui-web/state/personBase/BasePersonContextProvider';
import AddressTypeContextProvider from '@usas/ui-web/state/addressType/AddressTypeContextProvider';
import SearchMemberContextProvider from '@usas/ui-web/state/searchMember/SearchMemberContextProvider';
import ReportPeriodSeasonContextProvider from '@usas/ui-web/state/reportPeriodSeason/ReportPeriodSeasonContextProvider';
import GroupPersonCoachesContextProvider from '@usas/ui-web/state/groupPersonCoaches/GroupPersonCoachesContextProvider';

const MemberContextProviders = ({ children }) => {
  return (
    <AddressTypeContextProvider>
      <SearchMemberContextProvider>
        <BasePersonContextProvider>
          <BaseMemberContextProvider>
            <ReportPeriodSeasonContextProvider>
              <GroupPersonCoachesContextProvider>
                {children}
              </GroupPersonCoachesContextProvider>
            </ReportPeriodSeasonContextProvider>
          </BaseMemberContextProvider>
        </BasePersonContextProvider>
      </SearchMemberContextProvider>
    </AddressTypeContextProvider>
  );
};

export default MemberContextProviders;